import React, {useState, useEffect} from "react";
import { Platform } from "react-native";
// import WebCreditCard from "./CardWebComponent"
// import RNCreditCard from "./CardRNComponent";

const CreditCard = ({selectedCard}) => {
    const [Component, setComponent] = useState(null);

    useEffect(() => {
      if (Platform.OS === "web") {
        import("./CardWebComponent").then((module) => {
          const WebCreditCard = module.default;
          setComponent(() => <WebCreditCard selectedCard={selectedCard} />);
        });
      } else {
        import("./CardRNComponent").then((module) => {
          const RNCreditCard = module.default;
          setComponent(() => <RNCreditCard selectedCard={selectedCard} />);
        });
      }
    }, [selectedCard]);
  
    if (!Component) {
      return null; // 加载中的处理，你可以根据需要返回一个加载中的状态或占位符组件
    }
  
    return Component;
}

export default CreditCard;
